import * as React from 'react';
import * as classnames from 'classnames/bind';
import { connect } from 'react-redux';
import { withSiteData } from 'react-static';

import styles from './Form.scss';
import { RootState } from '../../RootState';
import { Language } from '../../containers/Localization/localizationDuck';
import { SiteProps } from '../../SiteProps';

const cx = classnames.bind(styles);

interface OwnProps {
  title: string;
  loading?: boolean;
  error?: string;
}

interface StateProps {
  language: Language;
}

export interface FormProps extends OwnProps, StateProps, SiteProps {}

const Form: React.SFC<FormProps> = ({ children, title, loading, error, language, formErrors }) => (
  <div className={styles.form}>
    <h2 className={styles.headText}>{title}</h2>
    <div className={cx('content', { loading })}>
      <>
        {children}
        {error && <span className={styles.error}>{formErrors[language][error]}</span>}
      </>
    </div>
  </div>
);

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

export default connect<StateProps, {}, OwnProps, RootState>(mapStateToProps, () => ({}))(
  withSiteData(Form),
);



// WEBPACK FOOTER //
// /www/client/src/components/Form/Form.tsx